import { BaseModel } from '../../../global/models';
import { PageSize } from './print-settings.models';

export interface PrinterSettings extends BaseModel {
  bnOnColorFilterMaxPct?: number;
  bnOnColorFilterMaxSides?: number;
  bnOnColorMonthlyCurrent?: number;
  bnOnColorMonthlyMax?: number;
  bnOnColorWarnPct?: number;
  bnOnColorWarnPctByManufacturer?: Record<string, number>;
  colorOnBnFilterMaxPct?: number;
  colorOnBnFilterMaxSides?: number;
  editPrinterSettingsAllowed?: boolean;
  ip?: string;

  largerPageSizeAllowed?: boolean;
  largerPageSizeAllowedByRole?: Partial<Record<RoleName, PageSize[]>>;

  maxBnSheetsPerBulk?: number;
  maxColorSheetsPerBulk?: number;
  maxLaminatedCoversPerBulk?: number;
  maxOrdersPerBulk?: number;

  mixedPrintAllowed?: boolean;
  mixedPrintAllowedByRole?: Partial<Record<RoleName, MixedPrintType[]>>;
  mixedPrintAutoBlock?: boolean;
  mixedPrintAutoUnblock?: boolean;

  pendingOrdersOffsetMinutes?: number;
  preprocessThreadLimit?: number;
  printEnabled?: boolean;
  settingsLabels?: unknown[];

  uriTemplate?: string;
  uriTemplateIpp?: string;
  uriTemplateKonica?: string;
  uriTemplateZpl?: string;

  workStationFilterTypesByWarehouse?: Partial<Record<WarehouseId, string[]>>;
}

type RoleName = 'admin' | 'printer' | 'superAdmin';
export enum WarehouseId {
  ANY = 'w0',
  W1 = 'w1',
  W3 = 'w3',
  FIX = 'fix',
}
type MixedPrintType = 'M1' | 'M2' | 'M3' | 'M4';
